import { addTheme } from 'tamagui'
import { IThemeSeed, schoolThemeName, schoolThemeValues } from './buildTheme'

const registered = new Set<string>()

/** Registra o tema da escola no Tamagui (uma vez por seed) e devolve o nome. */
export function registerSchoolTheme(seed: IThemeSeed): string {
  const name = schoolThemeName(seed)
  if (registered.has(name)) return name

  addTheme({ name, theme: schoolThemeValues(seed) })
  registered.add(name)

  return name
}
